import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/reviews';
export function Reviews() {
  return <section aria-labelledby="reviews-heading" className="w-full bg-kosin-mist" data-id="element-257" data-mp="2hddo1lbcew3k">
      <div className="mx-auto max-w-shell px-[18px] py-12 sm:px-6 lg:py-20" data-id="element-258" data-mp="2mbfhn06eadta">
        <h2 id="reviews-heading" className="text-[28px] font-bold leading-tight text-kosin-charcoal lg:text-[36px]" data-id="element-259" data-mp="2raif9zk1phr8">
          What Customers Tell Us
        </h2>

        <ul className="mt-9 grid grid-cols-1 gap-8 md:grid-cols-3 lg:mt-12" data-id="element-260" data-mp="30bggyb70hd6n">
          {reviews.map(review => <li key={review.name} className="flex h-full flex-col" data-id="element-261" data-mp="351olsflqsfnm">
              <div className="flex items-center gap-1" aria-hidden="true" data-id="element-262" data-mp="354j6874ra0h1">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-[15px] w-[15px] fill-kosin-red text-kosin-red" data-id="element-263" data-mp="3f0w8vuia3onx" />)}
              </div>
              <span className="sr-only" data-id="element-264" data-mp="2rce17wgnopjr">5-star review</span>
              <blockquote className="mt-4 text-[17px] leading-relaxed text-kosin-ink" data-id="element-265" data-mp="2rdyuzjv5c4gk">
                “{review.quote}”
              </blockquote>
              <div className="mt-auto pt-5" data-id="element-266" data-mp="2hdy8jp1zd885">
                <p className="text-[15px] font-semibold text-kosin-charcoal" data-id="element-267" data-mp="2heri0xsbqbtz">
                  {review.name}
                </p>
                <p className="text-[14px] text-kosin-body" data-id="element-268" data-mp="3a35g1djex85j">
                  {review.category} · 5-star review
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}